<template>
  <div class="w-100">
    <indeterminate-line v-if="loading" class="mh2-l"/>
    <div v-else-if="error" class="ma4">Ошибка: {{ error }}</div>
    <div v-else>
      <div class="list-grid">
        <div v-for="(item, index) in templates" :key="index" class="list-item" id="document_templates"
          @click.stop="onEdit(item)">
          <div class="lh-copy text-line-1" id="document_template_title">
            {{ item.title }}
          </div>
          <span class="bl b--near-white pv3"></span>
          <button  @click.stop="onDownload(item)" class="input-icon-button bg-transparent text-secondary">
            <font-awesome-icon icon="file-download" class=""/>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginator from '@/components/Paginator.vue'
import IndeterminateLine from '@/components/ui/progress/IndeterminateLine.vue'
import { DataService } from '@/services/DataService.js'
import { download } from '@/utils/download'

export default {
  components: {
    Paginator,
    IndeterminateLine
  },
  props: ['loading', 'templates', 'error'],
  methods: {
    onEdit (item) {
      this.$router.push({ name: 'document_template', params: { id: item.id } })
    },
    onDownload (item) {
      DataService
        .loadDocumentTemplate({ templateId: item.id })
        .then(({ data: { loadDocumentTemplate: { data, name } } }) => download(data, name))
    }
  }
}
</script>

<style lang="scss" scoped>
.list-grid {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 1fr;
  grid-gap: 1px;
  background-color: #F0F4F8;
  padding-top: 1px;
  padding-bottom: 1px;
}
.list-item {
  display: grid;
  grid-template-columns: 1fr 1px auto;
  grid-column-gap: 0rem;
  grid-row-gap: 1rem;
  align-items: center;
  padding: .1rem .1rem .1rem 1rem;
  background-color: #FFFFFF;
  &:hover, :focus {
    background-color: #f6f7f9;
    cursor: pointer;
  }
}
.item-layout {
  display: grid;
  grid-template-columns: 1fr 300px;
  grid-template-rows: 1fr;
  grid-gap: 2px;
  align-items: center;
}
.items-details {
  display: grid;
  grid-template-columns: 5rem 1fr;
  grid-template-rows: 1fr;
  grid-gap: 2px;
}
.bg-input-button {
  background-color: inherit;
  color: #BCCCDC;
}
</style>
